import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isNull } from 'lodash';
import { RuntimeContext } from '../../../../../../../common/RuntimeContext';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';
import PeopleSearchSelect from '../../../../../../shared/components/PeopleSearchSelect';
import SearchForm from '../../../../../../shared/containers/forms/SearchForm';
import { TeamMembersTable } from '../CompanyTeamMemberTables';
// import { TeamMembersTable, TeamLeadsTable } from '../CompanyTeamMemberTables';
// import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';

export default class CompanyTeamMembers extends Component {
    static propTypes = {
        changeFormValue: PropTypes.func,
        changeSearchFormValue: PropTypes.func,
        company: PropTypes.object,
        currentValues: PropTypes.object,
        getTeamAdmin: PropTypes.func,
        membersById: PropTypes.object,
        teamMembers: PropTypes.array,
        team: PropTypes.object,
        updateTeamMembers: PropTypes.func,
        isInstructionalAdmin: PropTypes.bool,
        searchForParticipants: PropTypes.func,
        defaultMemberSearchOptions: PropTypes.array,
        updateProfile: PropTypes.func,
        membersToAdd: PropTypes.array,
        handleMemberSelectChange: PropTypes.func,
        forceClearSearchSelect: PropTypes.bool,
        handleMemberRemoveChange: PropTypes.func,
        // isVerbAdmin: PropTypes.bool,
        // postSearchedCompanyMemberProfiles: PropTypes.func,
        // teamLeadProfiles: PropTypes.array,
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            addMembersErrorMessage: '',
            addOrRemoveTeamLeadsSuccessMessage: '',
            hasSearchFilter: false,
            membersToRemove: [],
            removeMembersSuccessMessage: '',
            teamLeadsToRemove: [],
            updatingMembers: false,
            searchedTeamMembers: null,
            currentSearchQuery: '',
            sortKey: 'name',
            sortOrder: 1,
            membersToAdd: props.membersToAdd,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.membersToAdd !== this.props.membersToAdd) {
            this.setState({ membersToAdd: this.props.membersToAdd })
        }
    }

    // Firstname LastName: workEmail (employee#)
    _formOptions = (values, membersById) => {
        let valuesArray;
        if (values) {
            valuesArray = values.map((item) => {
                const name = `${item.name || ''} ${item.name ? ': ' : ''}`;
                return {
                    value: item.personId,
                    label: `${name}${item.email || ''}${item.employeeNumbersCollection ? ` ${item.employeeNumbersCollection}` : ''}`
                };
            });
            valuesArray = valuesArray.filter((option) => !membersById[option.value]);

            valuesArray.push({
                value: 'disable',
                label: `Try refining your search if you can't find who you're looking for.`,
                isDisabled: true
            });
        }
        return valuesArray;
    };

    // handleCompanyTeamMemberSearch = (hits, queryParams = { query: '' }) => {
    //     const { postSearchedCompanyMemberProfiles } = this.props;
    //     if (hits && hits._id && hits._id.length) {
    //         const { company, team } = this.props;
    //         const body = {
    //             companyId: company._id,
    //             ...hits,
    //             sortField: `invitedDateTime`,
    //             sortOrder: -1,
    //             teamId: team._id,
    //             getInvitedAndUnregistered: true,
    //             pathsContext: this.context.pathsWeb
    //         };

    //         return postSearchedCompanyMemberProfiles(body).then((userProfiles) =>
    //             this.setState({
    //                 invitedMembers: userProfiles,
    //                 hasSearchFilter: true,
    //                 hits,
    //                 currentSearchQuery: queryParams.query
    //             })
    //         );
    //     }

    //     // This is horrible and I'm sorry. Our search returns an empty array if search is not executed.
    //     // Otherwise it returns an object.
    //     const searchReturnedDefaultArray = Array.isArray(hits);
    //     const searchFoundNoResults = !searchReturnedDefaultArray && hits && hits._id && Array.isArray(hits._id);
    //     const setStateParams = {
    //         hits: {},
    //         hasSearchFilter: !Array.isArray(hits)
    //     };

    //     if (searchFoundNoResults) {
    //         setStateParams.invitedMembers = [];
    //     }
    //     return this.setState(setStateParams);
    // };

    // handleMemberSelectChange = (values) =>
    //     this.setState({
    //         membersToAdd: values,
    //         forceClearSearchSelect: false
    //     });

    handleClearSearchBar = (params) => {
        const { searchVal } = params;
        const { invitedMembers } = this.props;
        if (!searchVal) {
            this.setState({
                invitedMembers,
                hasSearchFilter: false,
                hits: {}
            });
        }
    };

    toggleReadyToRemove = (type) => (id) =>
        this.setState((prevState) => {
            const key = `${type}ToRemove`;

            const newMembersToRemove = [...prevState[key]];

            const index = newMembersToRemove.indexOf(id);
            if (index > -1) {
                newMembersToRemove.splice(index, 1);
            } else {
                newMembersToRemove.push(id);
            }
            return {
                [key]: newMembersToRemove
            };
        });

    handleRemoveMembers = () => {
        const {
            team: { _id: teamId },
            updateTeamMembers,
            getTeamAdmin,
            updateProfile,
            handleMemberRemoveChange,
        } = this.props;
        const { membersToRemove, membersToAdd } = this.state;
        const filteredMembers = membersToAdd.filter(
            member => !membersToRemove.includes(member.value)
        )
        const confirmation = window.confirm('Are you sure you want to remove these team members?');
        if (membersToRemove.length && confirmation) {
            return updateTeamMembers({
                teamId,
                action: 'remove',
                membersToUpdate: membersToRemove,
                pathsContext: this.context.pathsWeb
            }).then((response) => {
                handleMemberRemoveChange(filteredMembers);
                getTeamAdmin({
                    teamId,
                    getRegistered: false,
                    getAllMembers: true,
                    pathsContext: this.context.pathsWeb
                });
                this.setState({
                    membersToRemove: [],
                    removeMembersSuccessMessage: `${membersToRemove.length} members have been removed from the team.`,
                });
                updateProfile(response)
            });
        }
        return null;
    };

    // TODO for GA - TEAM LEADS
    // handleAddTeamLeads = () => {
    //     const {
    //         changeFormValue,
    //         currentValues: { teamLeads = [], teamLeadsToAdd = [] }
    //     } = this.props;

    //     const teamLeadsToAddId = teamLeadsToAdd.map((member) => member.value);
    //     const newTeamLeads = [...teamLeads, ...teamLeadsToAddId];

    //     this.setState({
    //         addOrRemoveTeamLeadsSuccessMessage: `${teamLeadsToAddId.length} team lead(s) successfully added`
    //     });

    //     changeFormValue({
    //         field: 'teamLeads',
    //         value: newTeamLeads
    //     });
    //     changeFormValue({
    //         field: 'teamLeadsToAdd',
    //         value: []
    //     });
    // };

    // TODO TEAM LEADS
    // handleRemoveTeamLeads = () => {
    //     const { currentValues: { teamLeads = [] } = {}, changeFormValue } = this.props;
    //     const { teamLeadsToRemove } = this.state;
    //     const newTeamLeads = teamLeads.filter((id) => teamLeadsToRemove.indexOf(id) < 0);

    //     this.setState({
    //         addOrRemoveTeamLeadsSuccessMessage: `${teamLeadsToRemove.length} team lead(s) successfully removed`,
    //         removeTeamLeadsSuccessMessage: '',
    //         teamLeadsToRemove: []
    //     });

    //     changeFormValue({
    //         field: 'teamLeads',
    //         value: newTeamLeads
    //     });
    // };

    // manual search to support MCC teams
    handleRegisteredQuery = (results, searchProps) => {
        const { teamMembers } = this.props;
        const { query } = searchProps;
        const filteredTeamMembers = teamMembers.filter(
            ({ firstName, lastName, email }) =>
                firstName.toLowerCase().match(new RegExp(query.toLowerCase()), 'gi') ||
                lastName.toLowerCase().match(new RegExp(query.toLowerCase()), 'gi') ||
                email.toLowerCase().match(new RegExp(query.toLowerCase()), 'gi')
        );

        this.setState({ searchedTeamMembers: filteredTeamMembers });
    };

    clearSearch = () => {
        this.props.changeSearchFormValue({
            field: 'searchVal',
            value: ''
        });
        this.setState({ currentSearchQuery: '' });
    };

    setSortKey = (newKey) => {
        const { sortKey, sortOrder } = this.state;
        let newSortOrder = sortOrder;
        if (newKey === sortKey) {
            newSortOrder = sortOrder * -1;
        }
        this.setState({ sortKey: newKey, sortOrder: newSortOrder });
    };

    handleLoadOptions = () => {};

    render() {
        const {
            teamMembers,
            team = {},
            currentValues: { teamLeads = [], teamLeadLabel },
            searchForParticipants,
            membersById,
            defaultMemberSearchOptions,
            tenantId = '',
            // membersToAdd,
            handleMemberSelectChange,
            forceClearSearchSelect,
            // company,
            // teamLeadProfiles,
            // isInstructionalAdmin,
            // isVerbAdmin
        } = this.props;
        const {
            addMembersErrorMessage,
            // addOrRemoveTeamLeadsSuccessMessage,
            // hasSearchFilter,
            // hits,
            searchedTeamMembers,
            membersToRemove,
            removeMembersSuccessMessage,
            // selectedMembersTab,
            // teamLeadsToRemove,
            sortOrder,
            sortKey,
            membersToAdd,
        } = this.state;

        const teamLeadSelectOptions = [];
        let filteredTeamMembers = teamMembers;
        if (!isNull(searchedTeamMembers)) {
            filteredTeamMembers = searchedTeamMembers;
        }

        filteredTeamMembers.forEach((member) => {
            if (teamLeads && teamLeads.indexOf(member._id) < 0) {
                teamLeadSelectOptions.push({
                    value: member._id,
                    label: `${member.firstName || ''} ${member.lastName || ''}`
                });
            }
        });

        const updatedMembersToAdd = membersToAdd.map(member => {
            const match = defaultMemberSearchOptions.find(option => option.personId === member.value);
            return {
                ...member,
                firstName: match ? match.name : member.label,
                employeeNumberCollection: match ? match.employeeNumber : '',
                _id: member.value,
            }
        });

        updatedMembersToAdd.forEach(member => {
            membersById[member.value] = member;
        })

        return (
            <>
                <div className={'team-members-section-container col-12'}>
                    <div className={'team-members-container'}>
                        <div className={'team-members-container-add'} >
                            <div>
                                <h4 className={'verb-title-4'}>Add Existing Members to Team</h4>
                                <small className={'col-12 col-sm-8'}>
                                    Use the dropdown to add a member to this specific team.
                                </small>
                            </div>
                            <PeopleSearchSelect
                                formOptions={this._formOptions}
                                className={'col-sm-8 col-12'}
                                isMulti={true}
                                sortBy={(a, b) => (a.lastName < b.lastName ? -1 : 1)}
                                handleSelect={handleMemberSelectChange}
                                forceClear={forceClearSearchSelect}
                                searchForParticipants={searchForParticipants}
                                membersById={membersById}
                                defaultOpts={defaultMemberSearchOptions}
                                pathsContext={this.context.pathsWeb}
                                initializeSearch
                                tenantId={tenantId}
                                showValues={false}
                            />
                        </div>
                        {addMembersErrorMessage ? (
                            <div className={'row error-message ms-auto'}>{addMembersErrorMessage}</div>
                        ) : null}
                        {/* <div className={'row'}>
                            <PeopleSearchSelect
                                formOptions={this._formOptions}
                                className={'col-sm-8 col-12'}
                                isMulti={true}
                                sortBy={(a, b) => (a.lastName < b.lastName ? -1 : 1)}
                                handleSelect={this.handleMemberSelectChange}
                                forceClear={forceClearSearchSelect}
                                searchForParticipants={searchForParticipants}
                                membersById={membersById}
                                defaultOpts={defaultMemberSearchOptions}
                                pathsContext={this.context.pathsWeb}
                                initializeSearch
                                tenantId={tenantId}
                            />
                        </div> */}
                        {(team.members && team.members.length) || (updatedMembersToAdd && updatedMembersToAdd.length) ? (
                            <Fragment>
                                <div className={'col-sm-12 tabListControl company-tab-list'}>
                                    <ul className={`col-12 tabList rightTabAlignment`}>
                                        <li className={'active-tab'}>
                                            PARTICIPANTS
                                            <strong> ({teamMembers.length})</strong>
                                        </li>
                                    </ul>
                                </div>
                                <div className={'row'}>
                                    <VerbButton
                                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                                        onClick={this.handleRemoveMembers}
                                        fontAwesomeIcon={'fal fa-trash'}
                                        disabled={!membersToRemove.length}
                                        className={'team-members-remove-button'}
                                    >
                                        Remove Members
                                    </VerbButton>
                                    {
                                        // <div className={'col-12 col-sm-6 ms-auto'}>
                                        //     <div className={'col-sm-12 company-member-search'}>
                                        //         <SearchForm
                                        //             indexName={'Profile'}
                                        //             showBottomBorder={false}
                                        //             showFullBorder={true}
                                        //             handleSearchResults={this.handleRegisteredQuery}
                                        //             onClearSearch={this.clearSearch}
                                        //             pathsContext={this.context.pathsWeb}
                                        //         />
                                        //     </div>
                                        // </div>
                                    }
                                </div>
                                <div className={'row col-6'}>
                                    <div className={'row success-message ms-auto'}>{removeMembersSuccessMessage}</div>
                                </div>
                                <TeamMembersTable
                                    teamMembers={filteredTeamMembers}
                                    teamLeads={teamLeads}
                                    membersToRemove={membersToRemove}
                                    teamLeadLabel={teamLeadLabel}
                                    flagForRemoval={this.toggleReadyToRemove('members')}
                                    makeTeamLead={this.handleMakeTeamLead}
                                    sortOrder={sortOrder}
                                    sortKey={sortKey}
                                    setSortKey={this.setSortKey}
                                    teamId={team._id}
                                    membersToAdd={updatedMembersToAdd}
                                />
                            </Fragment>
                        ) : (
                            <div> This team currently has no members. </div>
                        )}
                    </div>
                    {
                        // <div className={'team-leads-container'}> // TEAM LEADS SECTION
                        //     <div className={'row'}>
                        //         <h4>Assign Team Leads</h4>
                        //     </div>
                        //     <div className={'row'}>
                        //         <small className={'col-12 col-sm-8'}>
                        //             Use this field to assign team leads. If you can’t find their name, make sure they have
                        //             been added or invited to this specific team. Teams leads are able to feature
                        //             collections, invite learners, and make team announcements.
                        //         </small>
                        //         <VerbButton
                        //             buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        //             fontAwesomeIcon={'fa-plus'}
                        //             onClick={this.handleAddTeamLeads}
                        //             disabled={!teamLeadsToAdd.length}
                        //             className={'ms-auto'}
                        //         >
                        //             Add Team Leads
                        //         </VerbButton>
                        //     </div>
                        //     <div className={'row team-lead-success-message '}>{addOrRemoveTeamLeadsSuccessMessage}</div>
                        //     <br />
                        //     <div className={'row'}>
                        //         <Field
                        //             name={'teamLeadsToAdd'}
                        //             className={'col-12 col-sm-12 team-leads-select'}
                        //             options={teamLeadSelectOptions}
                        //             component={BasicSelect}
                        //             isMulti={true}
                        //             menuBuffer={15}
                        //             inputClassName={'col-sm-8 col-12'}
                        //         />
                        //     </div>
                        //     {teamLeadProfiles.length ? (
                        //         <div className={'team-leads-table-container'}>
                        //             <div className={'row'}>
                        //                 <VerbButton
                        //                     buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        //                     fontAwesomeIcon={'fa-trash'}
                        //                     onClick={this.handleRemoveTeamLeads}
                        //                     disabled={!teamLeadsToRemove.length}
                        //                     className={'mr-auto ml-2'}
                        //                 >
                        //                     Remove Team Leads
                        //                 </VerbButton>
                        //             </div>
                        //             <TeamLeadsTable
                        //                 teamLeads={teamLeadProfiles}
                        //                 teamLeadsToRemove={teamLeadsToRemove}
                        //                 flagForRemoval={this.toggleReadyToRemove('teamLeads')}
                        //             />
                        //         </div>
                        //     ) : (
                        //         <div> This team currently has no team leads. </div>
                        //     )}
                        // </div>
                    }
                </div>
            </>
        );
    }
}
